import { render, staticRenderFns } from "./DevSpace.vue?vue&type=template&id=106614eb&scoped=true"
import script from "./DevSpace.vue?vue&type=script&lang=js"
export * from "./DevSpace.vue?vue&type=script&lang=js"
import style0 from "./DevSpace.vue?vue&type=style&index=0&id=106614eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106614eb",
  null
  
)

export default component.exports